import { CartConstantsEnum as e } from "@commerce-cart-webcomponents/sdk";
const C = {
  WAREHOUSE_ID: "warehouseId",
  CHECKOUT_PROFILE: "checkoutProfile",
  SHARECODE_ATTRIBUTES: "sharecodeAttributes",
  CART_ID: e.CartId,
  CART_REQ_VERSION: e.CartReqVersion,
  NOTIFICATION_VERSION_NUMBER: "notificationVersionNumber"
};
var t = /* @__PURE__ */ ((o) => (o.CO_APPLICANT = "/co-applicant", o.ACCOUNT_RENEWAL = "account-renewals", o))(t || {});
const n = {
  SHARE_CHANNEL_CONFIG: "shareChannelConfig"
};
var a = /* @__PURE__ */ ((o) => (o.abo = "abo", o.lang = "lang", o))(a || {});
export {
  a as LinkQueryParamsEnum,
  C as LocalStorageKeys,
  n as SessionStorageKeys,
  t as UrlKeyEnum
};
//# sourceMappingURL=common.js.map
